// 审核中
export const NOTICE_VERIFYING = 0

// 审核通过
export const NOTICE_PASSED = 1

// 审核不通过
export const NOTICE_REJECTED = 2

export const VERIFYING_TEXT = '审核中，审核通过后将在客户端显示'
export const PASSED_TEXT = '审核通过，客户端显示中'
export const REJECTED_TEXT = '审核不通过，请修改后重新提交'
